import { memo } from "react";
import { monthArray, ordinal_suffix_of, weeksArray } from "src/utils/constants";
import { IMeeting } from "..";
import { List, Text, useMantineTheme, Box } from "@mantine/core";
import { getTimeInAMPMFormat } from "src/utils/dateHelper";

type IProps = {
  meetingDates: Record<string, IMeeting>;
  handleModal: (id?: string | null, start?: Date) => void;
  date: string;
};

function ListItem({ meetingDates, handleModal, date }: IProps) {
  const theme = useMantineTheme();

  return (
    <>
      <List
        mt={15}
        styles={{
          item: {
            listStyle: "none",
            borderBottom: `1px solid ${theme.colors.secondary[0]}`,
            fontSize: 13,
            cursor: "pointer",
            ":hover": {
              color: theme.colors.primaryTextColor[6],
              background: theme.colors.primary[6],
            },
            "&:nth-of-type(even)": {
              backgroundColor: theme.colors.secondary[4],
              ":hover": {
                color: theme.colors.primaryTextColor[6],
                background: theme.colors.primary[6],
              },
            },
          },
        }}
      >
        <Text
          weight={600}
          size={15}
          style={{
            borderBottom: `1px solid ${theme.colors.secondary[0]}`,
            color: theme.colors.secondaryTextColor[6],
          }}
        >
          {weeksArray[new Date(date).getDay()]} -{" "}
          {monthArray[new Date(date).getMonth()]}{" "}
          {ordinal_suffix_of(new Date(date).getDate() + 1)}
        </Text>

        <Box p={"0px 15px"}>
          {Object.values(meetingDates[date]).map((detail) => (
            <List.Item
              key={detail.id}
              pl={5}
              py={2}
              onClick={() => handleModal(detail.id)}
              sx={{ color: theme.colors.secondaryTextColor[6] }}
            >
              {getTimeInAMPMFormat(detail.startAt)} - {detail.name},{" "}
              {detail.instructor &&
                `${detail.instructor.user.firstName} ${detail.instructor.user.lastName}`}
            </List.Item>
          ))}
        </Box>
      </List>
    </>
  );
}

export default memo(ListItem);
